import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";
import { Loader2Icon, RotateCcwIcon } from "lucide-react";

type ConversationResetButtonProps = {
  isResetting: boolean;
  isDisabled: boolean;
  onReset: () => void;
};

export function ConversationResetButton({
  isResetting,
  isDisabled,
  onReset,
}: ConversationResetButtonProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <AlertDialog>
      <Tooltip>
        <TooltipTrigger asChild>
          <AlertDialogTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              disabled={isResetting || isDisabled}
            >
              {isResetting ? (
                <Loader2Icon className="w-4 h-4 animate-spin" />
              ) : (
                <RotateCcwIcon className="w-4 h-4" />
              )}
            </Button>
          </AlertDialogTrigger>
        </TooltipTrigger>
        <TooltipContent side="top">
          {t("team.components.instruction.conversation.resetButton")}
        </TooltipContent>
      </Tooltip>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("team.components.instruction.conversation.resetConfirm.title")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(
              "team.components.instruction.conversation.resetConfirm.description"
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {t("team.components.instruction.conversation.resetConfirm.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onReset}>
            {t("team.components.instruction.conversation.resetConfirm.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
